<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/WVWFxW/tc-custom/9781466836600.jpg?1719991157233" alt="This image is the cover for the book Warlord, The Outlaw Chronicles"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Warlord, The Outlaw Chronicles
      </h1>
      <p class="bookDescription body article font2">
        <b>War and mystery draw a knight and friend of Robin Hood into dangerous territory in this action-packed historical adventure by the author of <i>King’s Man</i>.</b><br/><br/>Robert, Earl of Locksley, returns in the third entry in this compelling historical series that reimagines one of the most indelible figures in folklore—Robin Hood.<br/><br/>King Richard I, the Lionheart, is engaged in a bloody war to drive the French out of Normandy. Using the brutal tactics of medieval warfare—siege, savagery and scorched earth—the Lionheart gradually pushes back the forces of King Philip of France. By his side in this epic struggle are the erstwhile outlaw Robin Hood, and Sir Alan Dale, Robin’s loyal friend.<br/><br/>But while the battles rage, Alan is preoccupied with discovering the identity the man who ordered his father’s death ten years earlier—a mystery that leads him towards to Paris, deep into the heart of the enemy’s territory.<br/><br/><b>Praise for <i>Warlord</i></b><br/><br/>“A bloodcurdling tale of medieval greed, cruelty and honor. . . . Many of the fight scenes show the thrusts and parries in detail, as though the author were a witness. . . . The battles are what make the book thoroughly entertaining. A fast-paced and exciting story.” —<i>Kirkus Reviews</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Angus Donald
      </h2>
      
      <p class="authorDescription body article"><P>ANGUS DONALD was born in 1965 and educated at Marlborough College and Edinburgh University. He has worked as a fruit-picker in Greece, a waiter in New York and as an anthropologist studying magic and witchcraft in Indonesia. For the past fifteen years, he has been a journalist in Hong Kong, India, Afghanistan and London. He is the author of The Outlaw Chronicles, including <I>Outlaw</I>, <I>Holy Warrior</I>, and <I>King's Man</I>.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?448bd846